import {useState} from 'react';
import {AxiosError} from 'axios';
import {Shipment} from '@shipwell/backend-core-sdk';
import {useGetFullShipmentDetails} from 'App/containers/alertsDashboard/utils/hooks/useGetFullShipmentDetails';
export const RefetchShipmentData = ({
  shipmentId,
  children
}: {
  shipmentId: string;
  children: ({
    shipmentData,
    pollingError,
    isPollingRelatedOrders,
    getShipmentError
  }: {
    shipmentData?: Shipment;
    pollingError?: AxiosError;
    isPollingRelatedOrders: boolean;
    getShipmentError: AxiosError | null;
  }) => JSX.Element;
}) => {
  const [isPollingRelatedOrders, setIsPollingRelatedOrders] = useState(true);
  const [pollingError, setPollingError] = useState<AxiosError>();
  const [shipmentData, setShipmentData] = useState<Shipment>();
  const {
    queryInfo: {error: getShipmentError}
  } = useGetFullShipmentDetails(shipmentId, {
    enabled: !!shipmentId,
    refetchInterval: (data, query) => {
      const isAddingOrders = !data?.related_orders;
      //once created, poll the new shipment every 2 seconds until the related orders are available
      if (isAddingOrders && !query.state.error) {
        return 2000;
      }
      return 0;
    },
    onSuccess: (data) => {
      if (data?.related_orders) {
        setIsPollingRelatedOrders(false);
        setShipmentData(data);
      }
    },
    onError: (error) => {
      setIsPollingRelatedOrders(false);
      setPollingError(error);
    }
  });
  return children({
    shipmentData,
    isPollingRelatedOrders,
    getShipmentError,
    pollingError
  });
};
